export const CONTENT = {
    "labels": {
        "benefit_lookup": "Benefit Lookup",
        "member_payment_research": "Member Payment Research",  
        "my_profile": "My Profile", 
        "logoff": "Logoff",             
    }
}  